export default function(store) {
  return {
    redirectToRemote: link => {
      open(link, "_top");
    },
    redirectTo: link => {
      open(link, "_top");
    }
  };
}
